import React from "react";
import { useDropzone } from "react-dropzone";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button'
import { t } from "i18next";
import Text from './Text';

function Dropzone({ onDrop, accept, open, label, color, filename="file", error }) {

  const { getRootProps, getInputProps, isDragActive, acceptedFiles } =
    useDropzone({
      accept,
      onDrop,
    });

  const files = acceptedFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>


  ));

  return (
    <>

      <div className="paragraph">
        <Text variant="normal" text={label} color={color} />
      </div>

      <Box>
        <div {...getRootProps({ className: "dropzone" })}>
          <input className="input-zone" {...getInputProps()} />
          <div className="text-center">
            <Button 
              variant="outlined" 
              color={error ? "red" : "black"}
              fullWidth
              onClick={open}
            >
              {t(filename)}
            </Button>
          </div>
        </div>


      </Box>

    </>
  );
}

export default Dropzone;
